/**
 * Umožní statickou kontrolu názvu prvku typu při design time
 * @param name Název prvku typu
 */
export const nameof = <T>(name: Extract<keyof T, string>): string => name;
/**
 * Vytvoří funkci umožňující statickou kontrolu názvu prvku konkrétního typu T při design time
 */
export const nameofFactory = <T>() => (name: Extract<keyof T, string>): string => name;
